class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.hoverMedia = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
  }

  connectedCallback() {
    if (!this.mainDetailsToggle.classList.contains('ec-mega-menu')) return;
    this.events = new AbortController();
    const options = { signal: this.events.signal };
    this.addEventListener('pointerenter', (event) => {
      if (!this.hoverMedia.matches || event.pointerType !== 'mouse') return;
      clearTimeout(this.closeTimer);
      this.open();
    }, options);
    this.addEventListener('pointerleave', (event) => {
      if (!this.hoverMedia.matches || event.pointerType !== 'mouse') return;
      clearTimeout(this.closeTimer);
      this.closeTimer = setTimeout(() => {
        if (!this.contains(document.activeElement)) this.close();
      }, 250);
    }, options);
    this.addEventListener('focusin', () => clearTimeout(this.closeTimer), options);
    document.addEventListener('pointerdown', (event) => {
      if (!this.contains(event.target)) this.close();
    }, options);
    this.hoverMedia.addEventListener('change', () => this.close(), options);
  }

  disconnectedCallback() {
    clearTimeout(this.closeTimer);
    this.events?.abort();
  }

  open() {
    document.querySelectorAll('header-menu').forEach((menu) => {
      if (menu !== this) menu.close();
    });
    this.mainDetailsToggle.open = true;
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', 'true');
  }

  close() {
    clearTimeout(this.closeTimer);
    super.close();
  }

  onToggle() {
    if (!this.header) return;
    const isOpen = !!document.querySelector('header-menu details[open]');
    this.header.preventHide = isOpen;
    const stickyHeader = this.closest('sticky-header');
    if (stickyHeader) stickyHeader.preventHide = isOpen;
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', String(this.mainDetailsToggle.open));
    if (this.mainDetailsToggle.open) {
      document.documentElement.style.setProperty(
        '--header-bottom-position-desktop',
        `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
      );
    }
  }
}

customElements.define('header-menu', HeaderMenu);
